import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Route guard. Children render only when user is authenticated.
 *  - `adminOnly`: requires role === "admin"
 *  - `staffOnly`: requires role in ("admin", "staff")
 *  When both are set, adminOnly takes precedence (stricter).
 */
const ProtectedRoute = ({ children, adminOnly = false, staffOnly = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="lux-container py-24 text-center text-neutral-500">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (adminOnly && user.role !== "admin")
    return <Navigate to="/account" replace />;
  if (staffOnly && !["admin", "staff"].includes(user.role))
    return <Navigate to="/account" replace />;
  return children;
};

export default ProtectedRoute;
